<template>
  <Loading
    :contentSize="true"
    :state="loading"
  >
    <div
      class="wrapper"

      ref="wrapper"
    >
      <h1>{{ $t( "queryData" ) }}</h1>

      <div v-if="MLtid" class="progress" />

      <div class="row">
        <div class="block">
          <div class="tag">{{ $t( "Endpoint" ) }}</div>

          <Autocompleter
            v-if="endpoints"
            class="ac"
            v-model="endpoint"
            :getItems="endpointsAC"
            @ok="cls = $event"
          />
        </div>
      </div>

      <div class="row">
        <div class="block">
          <div class="tag">{{ $t( "Class" ) }}</div>
          <div class="misc" v-if="cls && cls.id">{{ cls.name }}</div>
          <div v-if="cls && cls.id && !( cls.id in classesProps )" class="loader" />

          <Autocompleter
            class="ac"
            v-model="cls"
            :getItems="classesRq"
            @ok="cls = $event"
          />

          <div
            class="listWrapper"
            v-if="cls && ( cls.id in classesProps )"
          >
            <div
              class="title"
              :class="sliderIsShow( cls.id ) ? 'opened' : 'closed'"
              @click="sliderToggle( cls.id )"
            >{{ $t( "ClassChosenProps" ) }}</div>
            <Slide
              :state="sliderIsShow( cls.id )"
            >
              <List
                :items="classesProps[ cls.id ]"

                @input="classesProps[ cls.id ] = $event"
              />
<!--
              <div
                v-for="id in classesProps[ cls.id ]"
              >
                {{ classSchema.attrs[ aid ] }}
              </div>
-->
            </Slide>
          </div>
        </div>
      </div>

      <div
        class="row"
        v-for="( row, i ) in rows"
        :key="i"
      >
          <template v-if="row.type == $options.rowTypes.connection">
            <div class="block">
              <div class="tag">{{ $t( $options.utils.capitalize( rowTypeById( row.type ) ) ) }}</div>
              <div class="misc" v-if="row.cls && row.cls.classConnected">{{ row.cls.classConnected.name }}</div>
              <div v-if="row.cls && row.cls.id && !( row.cls.id in classesProps )" class="loader" />

              <Button class="removeBlock"
                :title="$t( 'removeBlockClass' )"

                @click="removeBlock( row, i )"
              >
                <Icon
                  symbol="removeBold"
                  size="1em"
                />
              </Button>

              <Autocompleter
                class="ac"

                :value="row.cls"

                :getItems="classesConnectedRq"
                :getItemsParams="{ rowToExclude: i }"

                @input="rowSet( i, { ...row, cls: $event }, row )"
                @ok="rowSet( i, { ...row, cls: $event }, row )"
              />

              <div
                class="listWrapper"
                v-if="row.cls && ( row.cls.id in classesProps )"
              >
                <div
                  class="title"
                  :class="sliderIsShow( row.cls.id ) ? 'opened' : 'closed'"
                  @click="sliderToggle( row.cls.id )"
                >{{ $t( "ClassChosenProps" ) }}</div>
                <Slide
                  :state="sliderIsShow( row.cls.id )"
                >
                  <List
                    :items="classesProps[ row.cls.id ]"
                    :agg="true"
                    @input="classesProps[ row.cls.id ] = $event"
                  />
                </Slide>
              </div>
            </div>
          </template>

          <template v-else-if="row.type == $options.rowTypes.filtering">
            <div
              class="block"
              v-for="( col, j ) in row.cols"
              :key="j"
            >
              <div class="tag">{{ $t( $options.utils.capitalize( rowTypeById( row.type ) ) ) }}</div>

              <div class="combine">AND</div>

              <Button
                class="removeBlock"
                :title="$t( 'removeBlockFilter' )"

                 @click="removeBlock( row, i, col, j )"
              >
                <Icon
                  symbol="removeBold"
                  size="1em"
                />
              </Button>

              <div
                class="filter"
                v-for="( filter, k ) in col.filters"
                :key="k"
              >
                <Autocompleter
                  class="ac"

                  :value="filter.value1"

                  :getItems="classesSelectedProps"
                  :getItemsParams="{}"

                  @input="colFilterSet( i, j, k, { ...filter, value1: $event }, row )"
                  @ok="colFilterSet( i, j, k, { ...filter, value1: $event }, row )"
                />
                <template
                  v-if="filter.value1 && filter.value1.type"
                >
                  <div

                    class="comparison"
                  >
                    <div class="pad"
                      v-for="( mark, name ) in filterComparisons( filter.value1.type )"
                      :key="mark"

                      :title="$t( name )"

                      @click="$set( filter, 'comparison', name )"

                      :class="filter.comparison == name ? 'selected' : ''"
                    >
                    <input
                      type="radio"
                      :name="'filter_' + i + '_' + j + '_' + k"
                    />
                    {{ mark }}
                    </div>
                  </div>
                  <div
                    class="with"
                  >
                    <Autocompleter
                      class="ac"

                      v-if="filter.value1.type == 'reference'"

                      :value="filter.value2.cls"

                      :getItems="entitesFilteredByLabelRq"
                      :getItemsParams="{ classes: Object.keys( filter.value1.refs ) }"

                      @input="colFilterSet( i, j, k, { ...filter, value2: { ...filter.value2, cls: $event } }, row )"
                      @ok="colFilterSet( i, j, k, { ...filter, value2: $event }, row )"
                    />
                    <div
                      class="filterLiteralInput"

                      v-else
                    >
                      <input
                        type="text"

                        v-model="filter.value2.literal"
                      />
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <Button
              class="addBlock"

              v-if="row.cols.length"

              @click="colAdd( row )"
            >
              <Icon
                symbol="addBold"
                size="1em"
              />
            </Button>
          </template>
      </div>

      <div class="rowControls" v-if="this.cls.id">
        <Button @click="rowAdd( $options.rowTypes.connection )">
          <Icon
            symbol="addBold"
            size="1em"
          />

          {{ $t( "connecting" ) }}
        </Button>
        <Button @click="rowAdd( $options.rowTypes.filtering )">
          <Icon
            symbol="addBold"
            size="1em"
          />

          {{ $t( "filtering" ) }}
        </Button>

        <div class="reqResultsTitle"></div>
        <table
          v-if="result && result.misc.size"
          cellspacing="0"
          cellpadding="0"
          border="0"
          class="reqResults"
        >
          <thead>
            <tr>
              <th class="header" :colspan="result.misc.size + 2">{{ $t( "DataPattern" ) }}</th>
            </tr>
            <tr>
              <th>{{ $t( "Class" ) }}</th>
              <th>{{ $t( "Property" ) }}</th>
              <th
                v-for="i in result.misc.size"
                :key="i"
              >{{ $t( "Value" ) }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="( r, i ) in result.props"
              :key="i"
            >
              <td v-html="pathToHTML( r.path )"></td>
              <td>{{ r.label }}</td>
              <td
                v-for="j in result.misc.size"
                :key="j"
              >{{ j - 1 < r.items.length ? r.items[ j - 1 ].valueLabel || r.items[ j - 1 ].value : "" }}</td>
            </tr>
          </tbody>
        </table>
        <div
          v-else-if="result"

          class="result empty"
        >
          Ничего не найдено по данному запросу.
        </div>
      </div>

      <div class="controls" style="flex-wrap: wrap;">
        <Button
          @click="queryExecToItems()"
        >
          {{ $t( "queryExecToItems" ) }}
        </Button>

        <div style="flex-basis: 100%; width: 0; height: 3em; overflow: hidden;"></div>

        <span
          style="display: inline-block; position: relative; font-size: inherit; width: 15em;"
        >
          <select
            v-model="MLprop"
            style="font-size: inherit; height: 100%; width: 100%;"
          >
            <option
              v-for="( mlp, mlpk ) in $options.MLprops"
              :key="mlpk"
              :value="mlpk"
            >{{ mlpk }}</option>
          </select>
          <div style="position: absolute; top: -1.2em; left: 0.5em; font-size: 0.8em; border-radius: 0.2em; padding: 0.2em; background-color: #40B8ED; color: #FFFFFF;">Целевое свойство</div>
        </span>
        <Button
          @click="queryExecToFile()"
        >
          {{ $t( "queryExecToFile" ) }}
        </Button>
      </div>
    </div>

    <Modal
      :show="queryExecStatus !== null"
      :title="$t( 'queryExecToItemsModalTitle' )"
      :acceptButtonText="$t( 'Ok' )"

      @accept="queryExecStatus = null"
      @close="queryExecStatus = null"
    >
      <span v-html="queryExecStatus"></span>
    </Modal>

    <Modal
      :show="MLpipelineShow"
      :title="$t( 'MLtitle' )"
      :acceptButtonText="$t( 'Ok' )"

      @accept="MLpipelineShow = false"
      @close="MLpipelineShow = false"
    >
      <img
        ref="MLimage"
        :src="MLpipelineImage"
        alt="pipeline"
        :onload="MLpipelineImageCentering()"
      />
    </Modal>
  </Loading>
</template>

<script>

import dates from "@/dates"
import utils from "@/utils"
import config from "@/config"
import api from "@/api"
import ls from "@/ls"

import Icon from "@/components/Icon";
import Button from "@/components/Button";
import Loading from "@/components/Loading";
import Modal from "../components/Modal";
import Autocompleter from "../components/Autocompleter";
import Checkbox from "../components/Checkbox";
import List from "../components/List";
import Slide from "../components/SlideUpDown";

//!!!
import CSVmock from "@/ml_job_mock.js";

export default {
  name: "pageTable",

  components: {
    Checkbox,
    Icon,
    Loading,
    Modal,
    Button,
    Autocompleter,
    List,
    Slide
  },

  i18n: {
    messages: {
      ru: {
        queryData:          "Запрос данных",
        Connection:         "Соединение",
        equal:              "равно",
        equalNot:           "не равно",
        more:               "больше",
        moreEqual:          "больше или равно",
        less:               "меньше",
        lessEqual:          "меньше или равно",
        contains:           "содержит",
        containsNot:        "не содержит",
        removeBlockClass:   "удалить блок и все подчиненные ему элементы",
        removeBlockFilter:  "удалить только данный блок",
        connecting:         "соединение",
        filtering:          "фильтрация",
        queryDo:            "выполнить запрос",
        ClassChosenProps:   "Атрибуты результата",
        queryExecToFile:   "Сформировать",
        queryExecToFileTip:"Сформировать данные по запросу на сервере",
        queryExecToItems:   "Запросить",
        queryExecToItemsTip:"Запросить данные по запросу",
        queryExecToItemsModalTitle: "Формирование файла по запросу на сервере",
        QueryRequestErr:    "Ошибка запроса",
        NoMainClassIsSpecified: "Необходимо выбрать основной класс.",
        DataPattern:        "Образец данных",
        MLtitle:            "AutoML pipeline"
      },

      en: {
        queryData: "Data querying"
      },

      kz: {
        queryData: "Data querying"
      }
    }
  },

  utils,

  rowTypes: {
    connection: 1,
    filtering:  2,
    aggregation:3
  },

  inputOverflows( event, el ) {
    if ( !el ) el = event.srcElement;
    const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
    el.style.direction = isOverflowing && ( !event || event.type == "blur" ) ? "rtl" : "unset";
  },

  MLstatusTimeout: 60*1000,

  MLprops: {
    customerID:       "",
    gender:           "",
    SeniorCitizen:    "",
    Partner:          "",
    Dependents:       "",
    tenure:           "",
    PhoneService:     "",
    MultipleLines:    "",
    InternetService:  "",
    OnlineSecurity:   "",
    OnlineBackup:     "",
    DeviceProtection: "",
    TechSupport:      "",
    StreamingTV:      "",
    StreamingMovies:  "",
    Contract:         "",
    PaperlessBilling: "",
    PaymentMethod:    "",
    MonthlyCharges:   "",
    TotalCharges:     "",
    Churn:            ""
  },

  data() {
    return {
      loading: true,

      endpoints: [],

      endpoint: { id: null, name: null },

      cls: { id: null, name: null },

      classesProps: {},
      result: null,

      rows: [],

      slidersShow: {},

      queryExecStatus: null,

      MLpipelineShow: false,
      MLpipeline:     null,
      MLpipelineImage:null, //"data:image/svg+xml;base64,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", //null,
      MLtid:          null,

      MLprop:         "Churn"
    }
  },

  async mounted() {
//    const t = await this.autoMLrq( "/job/result", undefined, undefined, { job_id: 17 } );
//    console.log( "!!!", t.Pipeline.Pipeline.substring( 1, t.Pipeline.Pipeline.length - 1 ) );
//    console.log( "!!!", t );

    await this.endpointsGet();
    const eps = ls.get( "EndpointId", "editorView" );
    if ( eps && ( eps in this.endpoints ) ) this.endpoint = { id: eps, name: this.endpoints[ eps ] };

    this.loading = false;

    const el = this.$refs.wrapper;
    const elProcess = () => {
      const inps = el.querySelectorAll( "input[type=text]:not([data-overflow])" );
      for ( const i of inps ) {
        i.addEventListener( "focus", this.$options.inputOverflows );
        i.addEventListener( "blur", this.$options.inputOverflows );
        i.setAttribute( "data-overflow", true );
      }
    };
    elProcess();
    this.$options.observer = new MutationObserver( elProcess );
    this.$options.observer.observe( el, { attributes: true, childList: true } );
  },

  unmounted() {
    if ( this.$options.observer ) this.$options.observer.disconnect();
  },

  methods: {
    sliderToggle( id ) {
      this.$set( this.slidersShow, id, id in this.slidersShow ? !this.slidersShow[ id ] : false );
    },
    sliderIsShow( id ) {
      if ( id in this.slidersShow ) return this.slidersShow[ id ];

      this.$nextTick( () => { this.sliderToggle( id ); } );
    },
    pathToHTML( path ) {
      return path.split( ' ∪ ' ).join( '<span>∪</span>' );
    },

    filtersGetByClass( id ) {
      const filters = [];

      for ( const r of this.rows ) {
        for ( const c of r.cols ) {
          for ( const f of c.filters ) {
            if ( f.value1.cls.id == id ) {
              let value;
              if ( f.value1.type == "reference" ) value = /*utils.objGetFirstKey( f.value2.cls.classes ) + "." + */f.value2.cls.id;
              else {
                value = f.value2.literal;
                if ( f.value1.type == "http://www.w3.org/2001/XMLSchema#boolean" ) {
                  value = value.toLowerCase() == "да" ? "true" : "false";
                }
              }

              filters.push(
                {
                  URI:        f.value1.id,
                  Comparison: f.comparison,
                  Value:      value
                }
              );
            }
            else if ( f.value2.cls.id == id ) {
            }
          }
        }
      }

      return filters;
    },

    queryBuild( limit ) {
      this.$options.aliases = {};
      this.$options.aliasesCount = 0;

      const q = {
        endpoint: this.endpoint.id,
        clientId: this.clientId,
        data: {
          URI:      this.cls.id,

//          Offset: 0,

          ... limit && { Limit: 3 },

//          NoLabels: true,


          Return: { Properties: this.classPropsGetChecked( this.cls.id ) },

          Filters:  {
            Combine:  "and",
            Filters:  this.filtersGetByClass( this.cls.id )
          }
        }
      };

      const joins = [];

      for ( const r of this.rows ) {
        //connection
        if ( r.type == this.$options.rowTypes.connection ) {
          const cConToId = r.cls.classConnected.id;
          const cConWithId = r.cls.classToConnectWith.id;
          const cConById = r.cls.by.id;

          const filtersBelongs = this.filtersGetByClass( cConToId );

          const aggs = [];
          if ( cConToId in this.classesProps ) {
            const cas = this.classesProps[ cConToId ];
            for ( const pid in cas ) {
              if ( cas.hasOwnProperty( pid ) ){
                const p = cas[ pid ];
                if ( p.agg ) {
                  const alias = cConToId + "_" + pid + "_" + ( ++this.$options.aliasesCount );
                  this.$options.aliases[ alias ] = "∑ " + p.name;
                  aggs.push( { Method: "sum", Property: pid, Alias: alias } );
                }
              }
            }
          }

          const join = {
            URI: cConToId,

            Return: { Properties: this.classPropsGetChecked( cConToId ) },

            Aggregate: aggs,

            Filters: [
              {
                Combine: "and",
                Filters: [
                  {
                    URI: cConById,
                    Comparison: "equal",
                    Value: cConWithId + ".uri"
                  }
                ]
              }
            ]
          };

          //add aggregation properties to return properties
          for ( const i of join.Aggregate ) {
            q.data.Return.Properties.push( i.Alias );
            join.Return = undefined;
          }

/*
          if ( filtersBelongs.length ) {
            join.Filters[0].Filters.push(
              {
                Combine: "and",
                Filters: filtersBelongs
              }
            );
          }
*/
          if ( filtersBelongs.length ) {
            join.Filters[0].Filters.push( ...filtersBelongs );
          }

          joins.push( join );
        }
      }

      if ( joins.length ) q.data.Join = joins;

      return q;
    },

    async queryExecToItems() {
      this.loading = true;

      try {
        const q = this.queryBuild( 3 );
//console.log( q );
//this.loading = false;
//return;

        const ans = await this.$options.api.post.json(
          "/builder/query",
          q
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );

//        console.log( JSON.stringify( ans, null, "\t" ) );

        this.result = this.resultPropertiesExtractor( ans.items );
//        console.log( JSON.stringify( this.result, null, "\t" ) );

      }
      catch ( e ) {
        console.error( e );
        console.error( "QUERY REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'QueryRequestErr' ), message: e.message, type: "error" } );
      }

      this.loading = false;
    },

    async autoMLrq( path, params, file, paramsGet ) {
      const fileData = new FormData();
      let url = config.autoML.url + path;

      if ( file ) {
        const fileBlob = new Blob( [ file ], { type: "text/csv" } );
        fileData.append( "file", fileBlob );
      }

      if ( params ) {
        for ( let pName in params ) {
          if ( params.hasOwnProperty( pName ) ) {
            const pVal = params[ pName ];
            fileData.append( pName, pVal );
          }
        }
      }

      if ( paramsGet ) {
        let s = "";
        for ( let pName in paramsGet ) {
          if ( paramsGet.hasOwnProperty( pName ) ) {
            const pVal = paramsGet[ pName ];
            s += "&" + pName + "=" + encodeURIComponent( pVal );
          }
        }

        url += "?" + s.substr( 1 );
      }

      let ans = null;
      let ansT = null;
      let res = null;

      res = await fetch(
        url,
        {
          method:	"POST",
          headers: {
//  						Pragma:			"no-cache",
//							"Cache-Control":"no-cache"
            ...config.autoML.user && { Authorization: "Basic " + btoa( config.autoML.user + ":" + config.autoML.password ) },
          },
          credentials: "omit",
          body:	fileData
        }
      );

      if ( res.status >= 200 && res.status <= 299 ) {
        ansT = await res.text();
        ans = JSON.parse( ansT );

        return ans;
      }

      const e = new Error( "status" );
      e.rStatus = res.status;
      e.rData = await res.text();

      console.error( "Request to \"" + url + "\" is failed with status: " + e.rStatus + ", data: " + e.rData );

      throw new Error( "request status error: " + e.rStatus );
    },

    MLpipelineImageCentering() {
      if ( this.$refs["MLimage"] ) this.$refs["MLimage"].scrollIntoView( { behavior: "auto", block: "center", inline: "center" } );
    },
    async queryExecToFile() {
      this.loading = true;

      let queryExecStatus = null;

      try {
        const q = this.queryBuild( 3 );

        if ( !q.data.URI ) throw new Error( this.$t( "NoMainClassIsSpecified" ) );

        q.data.SaveCsv = utils.uniqueHashGen() + ".csv";
        q.data.ReturnCsv = true;

        const ans = await this.$options.api.post.json(
          "/builder/query",
          q
        );
        if ( !ans ) throw new Error( "malformed server answer" );

        let errors = [];
        if ( ans.error ) errors.push( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) errors.push( ...ans.errors );

        if ( errors.length ) queryExecStatus = '<b>Запрос выполнен с ошибками:<b /><br />' + ans.errors.join( '<br /><br />' );
        else {
          queryExecStatus = '<b>Запрос выполнен успешно.</b><br /><br />Файл сохранен на сервере под именем<br />\"<b>' + q.data.SaveCsv + '</b>"';

          if ( this.MLpipeline ) this.MLpipelineShow = true;
          if ( !ans.items || !ans.items.length ) throw new Error( "no CSV data found" );

          //!!!
          const csvFile = CSVmock;

//          const csvFile = ans.items[0].csv;
          if ( csvFile ) {
            //!!!
//            const ans = { Status:"Success", job_id: 17 };

            //create AutoML job
            const ans = await this.autoMLrq(
              "/job/create",
              undefined,
              csvFile,
              {
                target: this.MLprop, //"Churn",
                metric: "roc_auc"
              }
            );

            if ( !ans ) throw new Error( "invalid server answer" );

            if ( this.MLpipelineImage ) this.MLpipelineShow = true;

            const jobId     = ans.job_id || ans.Job_id;
            const jobStatus = ( "" + ans.Status ).toLowerCase();

            if ( jobStatus != "success" ) throw new Error( "job creation error (" + jobStatus + "): " + ( ans.Message ? ans.Message : "unknown" ) );
            if ( !jobId ) throw new Error( "can't obtain a job id" );

            //pending job status
            const jobRequest = async () => {
              try {
                //stop and clear timer
                if ( this.MLtid ) {
                  clearTimeout( this.MLtid );
                }

                const ans = await this.autoMLrq(
                  "/job/status",
                  undefined,
                  undefined,
                  {
                    job_id: jobId
                  }
                );
                if ( !ans ) throw new Error( "invalid answer" );

                const jobStatus = ( "" + ans.Status ).toLowerCase()

                if ( jobStatus == "completed" ) {
                  const ans = await this.autoMLrq(
                    "/job/result",
                    undefined,
                    undefined,
                    {
                      job_id: jobId
                    }
                  );
                  if ( !ans ) throw new Error( "invalid server answer" );

                  const jobStatus = ( "" + ans.Status ).toLowerCase()

                  if ( jobStatus == "error" ) throw new Error( "job result getting error: " + ans.Message ? ans.Message : "unknown" );

                  const pipeline      = ans.Pipeline;
                  this.MLpipeline     = pipeline;
                  this.MLpipelineImage= ans.Image;
                  this.MLpipelineShow = true;
                  await this.$nextTick();
                  this.MLpipelineImageCentering();

                  this.MLtid = null;
                }
                else if ( jobStatus == "error" ) throw new Error( "job status checking error: " + ans.Message ? ans.Message : "unknown" );
                else {
                  //start timer
                  this.MLtid = setTimeout(
                    jobRequest,
                    this.$options.MLstatusTimeout
                  );
                }
              }
              catch ( e ) {
                console.error( e );

                this.MLtid = setTimeout(
                  jobRequest,
                  this.$options.MLstatusTimeout
                );
/*
                //restart for special status codes
                if ( e.rStatus == 502 || e.rStatus == 504 || e.rStatus == 404 ) {
                  //start timer
                  this.MLtid = setTimeout(
                    jobRequest,
                    this.$options.MLstatusTimeout
                  );
                  return;
                }

                this.MLtid = null;
                console.error( e );
                this.$root.$emit( "notify", { header: "Ошибка задания AutoML", message: e.message, type: "error" } );
*/
              }
            };

            //noinspection ES6MissingAwait
            jobRequest();
          }
          else throw new Error( "file is empty" );
        }
      }
      catch ( e ) {
        console.error( "QUERY REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'QueryRequestErr' ), message: e.message, type: "error" } );
      }

      this.queryExecStatus = queryExecStatus;

      this.loading = false;
    },

    rowTypeById( id ) {
      for ( const i in this.$options.rowTypes ) {
        if ( this.$options.rowTypes.hasOwnProperty( i ) && this.$options.rowTypes[ i ] === id ) return i;
      }
    },

    endpointsAC() {
      const items = [];
      for ( const id in this.endpoints ) {
        if ( this.endpoints.hasOwnProperty( id ) ) items.push( { id, name: this.endpoints[ id ] } );
      }

      return items;
    },

    async endpointsGet() {
      let endpoints = {};

      try {
        const ans = await this.$options.api.post.json(
          "/endpoints",
            {
              clientId: this.clientId
            }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        endpoints = ans.items;
      }
      catch ( e ) {
        console.error( "ENDPOINTS REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'EndpointsRequestErr' ), message: e.message, type: "error" } );
      }

      this.endpoints = endpoints;
    },

    async classesRq( query ) {
      try {
        const ans = await this.$options.api.post.json(
          "/classes",
          {
            endpoint: this.endpoint.id,
            clientId: this.clientId,
            lang:     this.langInterf,
            query
          }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        return Object.values( ans.items );
      }
      catch ( e ) {
        console.error( "CLASSES REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'ClassesRequestErr' ), message: e.message, type: "error" } );
      }
    },

    async classesConnectedRq( query, params ) {
      try {
        const ans = await this.$options.api.post.json(
          "/classes/connected",
          {
            endpoint: this.endpoint.id,
            clientId: this.clientId,
            lang:     this.langInterf,
            query,
            classes:  this.rows.reduce(
              ( a, r, i ) => {
                if (
                    r.type == this.$options.rowTypes.connection && r.cls && r.cls.id &&
                    ( !params || params.rowToExclude !== i )
                ) a.push(
                  {
                    id:   r.cls.id,
                    by:   r.cls.by ? { id: r.cls.by.id, classId: r.cls.by.classId } : null,
                    toId: r.cls.classToConnectWith ? r.cls.classToConnectWith.id : null
                  }
                );

                return a;
              },
              [ { id: this.cls.id, by: null, toId: null } ]
            )
          }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        return Object.values( ans.items );
      }
      catch ( e ) {
        console.error( "CLASSES REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'ClassesRequestErr' ), message: e.message, type: "error" } );
      }
    },

    async entitiesRq(
      classes,
      filters,
      labelContains,
      itemsPerPage,
      page,
    ) {
      try {
        if ( !filters ) filters = {};
        if ( labelContains ) {
          filters["http://www.w3.org/2000/01/rdf-schema#label"] = {
            comparison: "contains",
		        values: labelContains
          }
        }
        const ans = await this.$options.api.post.json(
          "/entities",
          {
            endpoint: this.endpoint.id,
            clientId: this.clientId,
            lang:     this.langInterf,
            classes,
            filters,
            sort: {
              id:   "http://www.w3.org/2000/01/rdf-schema#label",
              type: "asc"
            },
            itemsPerPage,
            page: page || 1
          }
        );

        if ( !ans ) throw new Error( "malformed server answer" );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        return Object.values( ans.items );
      }
      catch ( e ) {
        console.error( "ENTITIES REQUEST ERROR: request items is failed with " + e.message, e.stack );
        this.$root.$emit( "notify", { header: this.$t( 'EntitiesRequestErr' ), message: e.message, type: "error" } );
      }
    },

    async entitesFilteredByLabelRq( query, params ) {
      const items = await this.entitiesRq( params.classes, undefined, query, 10, 1 );

      return items;
    },

    rowAdd( type ) {
      if ( !type ) type = this.$options.rowTypes.connection;

      this.rows.push(
        {
          type,
          cols: []
        }
      );

      this.colAdd( this.rows[ this.rows.length - 1 ], "and" )

      if ( type == this.$options.rowTypes.connection ) this.$options.classesSelectedProps = null;
    },

    colAdd( row, comparison ) {
      if ( !comparison ) comparison = "or";
      if ( row ) {
        row.cols.push(
          {
            comparison: "and",
            filters: [
              {
                comparison: "equal",
                value1: {
                  type: null,
                  cls: { id: null, name: null },
                  attr:{ id: null, name: null },
                },
                value2: {
                  type: null,
                  cls: { id: null, name: null },
                  attr:{ id: null, name: null },
                  literal: null
                }
              }
            ]
          }
        );
      }
    },

    rowSet( rowI, rowData, rowDataOld  ) {
      this.rows[ rowI ] = rowData;
      this.rows.splice( rowI + 1, this.rows.length - rowI );

      if ( rowData && rowData.cls && rowData.cls.id && !( rowData.cls.id in this.classesProps ) ) this.classPropsGet( rowData.cls.id );
    },

    colFilterSet( rowI, colI, filterI, filterData, filterDataOld  ) {
      this.$set( this.rows[ rowI ].cols[ colI ].filters, filterI, filterData );
    },

    async classesSelectedProps( query ) {
      const ret = [];

      if ( !this.$options.classesSelectedProps ) {
        try {
          const classes = [ this.cls.id ];
          for ( const r of this.rows ) {
            if ( r.type == this.$options.rowTypes.connection ) classes.push( r.cls.id );
          }

          const classSchemaRqs = [];
          for ( const c of classes ) classSchemaRqs.push(
            this.$options.api.post.json(
              "/schemas",
              {
                id:       c,
                endpoint: this.endpoint.id,
                clientId: this.clientId,
                lang:     this.langInterf
              }
            )
          );

          const classSchemaAnss = await Promise.all( classSchemaRqs );
          const props = [];
          for ( const ans of classSchemaAnss ) {
            if ( ans ) {
              if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

              const classSchema = ans.item;

              if ( classSchema && classSchema.attrs ) {
                for ( const aid in classSchema.attrs ) {
                  if ( classSchema.attrs.hasOwnProperty( aid ) ) {
                    const attr = classSchema.attrs[ aid ];

                    if ( !attr.archive ) props.push(
                      {
                        id:       aid,
                        name:     classSchema.name + "🠊" + attr.name,
                        nameShort:attr.name,
                        cls:      { id: classSchema.id, name: classSchema.name },
                        type:     attr.type,
                        refs:     attr.refs
                      }
                    );
                  }
                }
              }
            }
            else throw new Error( this.$t( "InvalidClassesSchemaAnswer" ) + "\"" + classes.join( ", " ) + "\"" );
          }


          props.sort(
            ( a, b ) => {
              let t = a.name.localeCompare( b.name );

              return t;
            }
          );

          this.$options.classesSelectedProps = props;
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }
      }

      if ( query ) query = ( "" + query ).toLowerCase();

      for ( const a of this.$options.classesSelectedProps ) {
        if ( !query || a.name.toLowerCase().includes( query ) ) ret.push( a );
      }

      return ret;
    },

    filterComparisons( type ) {
      let comparisons;

      switch ( ( "" + type ).toLowerCase() ) {
        case "reference":
          comparisons = {
            "equal":    "=",
            "notequal":  "<>"
          };
        break;

        case "http://www.w3.org/2001/xmlschema#boolean":
          comparisons = {
            "equal":    "=",
            "notequal":  "<>"
          };
        break;

        case "http://www.w3.org/2001/xmlschema#integer":
        case "http://www.w3.org/2001/xmlschema#double":
        case "http://www.w3.org/2001/xmlschema#date":
        case "http://www.w3.org/2001/xmlschema#datetime":
          comparisons = {
            "equal":        "=",
            "equalNot":     "<>",
            "more":         ">",
            "moreEqual":    ">=",
            "less":         "<",
            "lessEqual":    "<="
          };
        break;

        //as string
        default:
          comparisons = {
            "equal":        "=",
            "equalNot":     "<>",
            "contains":     "~",
            "containsNot":  "!~"
          };
      }

      return comparisons;
    },

    removeBlock( row, i, col, j ) {
      if ( col ) {
        this.rows[ i ].cols.splice( j, 1 );
      }
      else {
        this.rows.splice( i, this.rows.length - i + 1 );
      }
    },

    async classPropsGet( id ) {
      const props = [];

      if ( !( id in this.classesProps ) ) {
        try {
          const ans = await this.$options.api.post.json(
            "/schemas",
            {
              id:       id,
              endpoint: this.endpoint.id,
              clientId: this.clientId,
              lang:     this.langInterf
            }
          );

          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

            const classSchema = ans.item;

            if ( classSchema && classSchema.attrs ) {
              for ( const aid in classSchema.attrs ) {
                if ( classSchema.attrs.hasOwnProperty( aid ) ) {
                  const attr = classSchema.attrs[ aid ];

                  const isNum = attr.type == "http://www.w3.org/2001/XMLSchema#integer" || attr.type == "http://www.w3.org/2001/XMLSchema#double";

                  if ( !attr.archive ) props.push(
                    {
                      id:       aid,
                      name:     attr.name,
                      checked:  false,
                      ...isNum && { agg: false }
                    }
                  );
                }
              }
            }
            else throw new Error( this.$t( "InvalidClassesSchemaAnswer" ) + "\"" + id + "\"" );
          }
          else throw new Error( this.$t( "InvalidClassesSchemaAnswer" ) + "\"" + id + "\"" );

          props.sort(
            ( a, b ) => {
              let t = a.name.localeCompare( b.name );
              return t;
            }
          );
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }

        this.$set( this.classesProps, id, props.reduce( ( a, i ) => { const id = i.id; delete i.id; a[ id ] = i; return a; }, {} ) );
      }

      return this.classesProps[ id ];
    },

    classPropsGetChecked( id ) {
      const items = [];

      if ( id in this.classesProps ) {
        const cas = this.classesProps[ id ];
        for ( const pid in cas ) {
          if ( cas.hasOwnProperty( pid ) && cas[ pid ].checked ) items.push( pid );
        }
      }

      return items;
    },

    resultPropertiesExtractor( o, props, path, misc ) {
      if ( !props ) props = {};
      if ( !path ) path = "";
      if ( !misc ) misc = { size: 0 };

      if ( !o ) return props;

      for ( const item of o ) {
        const classes = item.Classes.reduce( ( a, i ) => { a += ( a ? ", " : "" ) + i.Label ? i.Label : i.URI; return a; }, "" );

        const pathC = ( path ? path + " ∪ " : "" ) + classes;

        if ( item.DatatypeProperties ) {
          for ( const p of item.DatatypeProperties ) {
            const label =
              item.Classes[0].URI in this.classesProps &&
              this.classesProps[ item.Classes[0].URI ] &&
              p.URI in this.classesProps[ item.Classes[0].URI ] &&
              this.classesProps[ item.Classes[0].URI ][ p.URI ] &&
              this.classesProps[ item.Classes[0].URI ][ p.URI ].name ?
              this.classesProps[ item.Classes[0].URI ][ p.URI ].name :
              ( this.$options.aliases && ( p.Variable in this.$options.aliases ) ? this.$options.aliases[ p.Variable ] : p.URI );

            const prop = {
              id:     item.URI,
              value:  p.Value
            };

            const pk = pathC + "_" + label;
            if ( !( pk in props ) ) props[ pk ] = {
              id:       p.URI,
              path:     pathC,
              label,
              isRef:    false,
              classes:  item.Classes.reduce( ( a, i ) => { a.push( i.URI ); return a; }, [] ),
              items: []
            };

            props[ pk ].items.push( prop );

            const s = props[ pk ].items.length;
            if ( misc.size < s ) misc.size = s;
          }
        }

        if ( item.ObjectProperties ) {
          for ( const p of item.ObjectProperties ) {
            const label =
              item.Classes[0].URI in this.classesProps &&
              this.classesProps[ item.Classes[0].URI ] &&
              p.URI in this.classesProps[ item.Classes[0].URI ] &&
              this.classesProps[ item.Classes[0].URI ][ p.URI ] &&
              this.classesProps[ item.Classes[0].URI ][ p.URI ].name ?
              this.classesProps[ item.Classes[0].URI ][ p.URI ].name : p.URI;

            const prop = {
              id:         item.URI,
              value:      p.Value,
              valueLabel: p.Label
            };

            const pk = pathC + "_" + label;
            if ( !( pk in props ) ) props[ pk ] = {
              id:       p.URI,
              path:     pathC,
              label,
              isRef:    true,
              classes:  item.Classes.reduce( ( a, i ) => { a.push( i.URI ); return a; }, [] ),
              items:    []
            };

            props[ pk ].items.push( prop );

            const s = props[ pk ].items.length;
            if ( misc.size < s ) misc.size = s;
          }
        }

//console.log( JSON.stringify( props, null, "\t" ) );
        this.resultPropertiesExtractor( item.JoinedItems, props, pathC, misc );
      }

      return path ? props : { props, misc };
    }
  },

  watch: {
    endpoint() {
      this.cls = { id: null, name: null };
    },

    async cls( nv, ov ) {
      this.rows = [];
      if ( this.cls && this.cls.id ) await this.classPropsGet( this.cls.id );
    }
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
  font-size: 1.5em;
  margin-bottom: 0.8em;
}

.wrapper {
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100vw;
  height: calc( 100vh - 4em );
  overflow: auto;
  box-sizing: border-box;
}

.wrapper > .row {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: flex-start;
}

.wrapper > .row > .block {
  display: inline-block;
  border-radius: 0.2em;
  border: solid 1px #40B8ED;
  padding: 1.5em 0.5em 0.5em 0.5em;
  background-color: #DBF1FF;
  margin: 1.5em 0 1.5em 3em;
  position: relative;
  min-width: 7em;
  min-height:2em;
}
.wrapper > .row > .block:before {
  content: "";
  position: absolute;
  top: -2.9em;
  left: 2em;
  height: 3em;
  width: 0;
  border: dashed #0081CA;
  border-width: 0 0 0 1px;
  display: none;
}
.wrapper > .row  > .block:nth-child(1):before {
  display: block;
}
.wrapper > .row  > .block:after {
  content: "";
  position: absolute;
  top: 1em;
  left: -3em;
  width: 3em;
  height: 0;
  border: dashed #0081CA;
  border-width: 1px 0 0 0;
}
.wrapper > .row  > .block:first-child:after {
  display: none;
}
.wrapper > .row > .block > .loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5000;
  pointer-events: none;
	background: url( "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2400 2400' width='24' height='24'%3E%3Cg stroke-width='200' stroke-linecap='round' stroke='%23000' fill='none'%3E%3Cpath d='M1200 600V100'/%3E%3Cpath opacity='.5' d='M1200 2300v-500'/%3E%3Cpath opacity='.917' d='M900 680.4l-250-433'/%3E%3Cpath opacity='.417' d='M1750 2152.6l-250-433'/%3E%3Cpath opacity='.833' d='M680.4 900l-433-250'/%3E%3Cpath opacity='.333' d='M2152.6 1750l-433-250'/%3E%3Cpath opacity='.75' d='M600 1200H100'/%3E%3Cpath opacity='.25' d='M2300 1200h-500'/%3E%3Cpath opacity='.667' d='M680.4 1500l-433 250'/%3E%3Cpath opacity='.167' d='M2152.6 650l-433 250'/%3E%3Cpath opacity='.583' d='M900 1719.6l-250 433'/%3E%3Cpath opacity='.083' d='M1750 247.4l-250 433'/%3E%3CanimateTransform attributeName='transform' attributeType='XML' type='rotate' keyTimes='0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667' values='0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199' dur='0.83333s' begin='0s' repeatCount='indefinite' calcMode='discrete'/%3E%3C/g%3E%3C/svg%3E" ) 50% 50% no-repeat;
	background-size: 32px;
}
.wrapper > .row > .block > .loader:after {
  content: "";
  position: absolute;
  top: -1em;
  left: -1em;
  right: -1em;
  bottom: -1em;
  background-color: rgba( 255, 255, 255, 0.5 );
  z-index: 4999;
}

.wrapper > .row  > .block > .combine {
  position: absolute;
  display: inline-block;
  top: 1.6em;
  left: -3em;
  font-size: 0.9em;
  padding: 0 0.2em;
  border-radius: 0.2em;
  background-color: #0081CA;
  font-weight: bold;
  color: #FFFFFF;
  width: unset;
  height: unset;
}
.wrapper > .row  > .block:first-child > .combine {
  display: none;
}

.wrapper > .row > .block > .tag {
  padding: 0 0.2em;
  position: absolute;
  top: -0.6em;
  left: 0.5em;
  border-radius: 0.2em;
  font-size: 0.9em;
  background-color: #40B8ED;
  color: #FFFFFF;
  display: inline-block;
  max-width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wrapper > .row > .block > .misc {
  padding: 0 0.2em;
  position: absolute;
  top: -0.6em;
  right: 0.5em;
  border-radius: 0.2em;
  font-size: 0.9em;
  background-color: #0081CA;
  color: #FFFFFF;
  display: inline-block;
  max-width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ac {
  font-size: 1.2em;
  background-color: #0081CA;
  color: #FFFFFF;
  border: none;
  border-radius: 0.2em;
  padding: 0.2em 1em;
  min-width: 20em;
}
.ac::v-deep input {
  border: none !important;
  background-color: #FFFFFF;
  color: #000000;
}
.ac::v-deep .results {
  background-color: #FFFFFF;
  color: #0081CA;
  border-color: #0081CA;
  max-width: 80vw;
  right: unset;
  min-width: 100%;
  border-radius: 0.2em;
  scrollbar-width: thin;
  box-sizing: border-box;
  box-shadow: 0 3px 3px rgba( 0, 0, 0, 0.5 );
  scrollbar-color: #0081CA #DBF1FF;
}
.ac::v-deep .results > .active,
.ac::v-deep .results .item:hover {
  background-color: #DBF1FF;
  color: #0081CA;
}
.ac::v-deep .results .item {
  white-space: nowrap;
}
.ac::v-deep input {
  text-overflow:ellipsis;
}

.rowControls {
  margin-top: 2em;
}
.rowControls > * {
  margin-right: 1em;
}
.rowControls > *:last-child {
  margin-right: 0;
}
.rowControls > button > svg {
  margin-right: 1em;
}

.removeBlock,
.addBlock {
  position: relative;
  width: 2em;
  height: 2em;
  border-radius: 0.2em;
  font-size: 0.9em;
  display: inline-block;
  cursor: pointer;
}

.addBlock {
  margin: 1.5em 0 0 1.5em;
}

.wrapper > .row > .block > .removeBlock {
  position: absolute;
  top: -2em;
  left: -2.4em;
  background-color: #ED4040;
  border-color: #C11515;
  color: #FFFFFF;
}
.wrapper > .row > .block > .removeBlock:hover {
  background-color: #EF7070;
}
.removeBlock > .icon,
.addBlock > .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  width: 70%;
  height: 70%;
}



.block .filter .comparison {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.filterLiteralInput {
  font-size: 1.2em;
  background-color: #0081CA;
  color: #FFFFFF;
  border: none;
  border-radius: 0.2em;
  padding: 0.2em 1em;
  min-width: 20em;
}
.filterLiteralInput input {
  border: none !important;
  background-color: #FFFFFF;
  color: #000000;
  border-radius: 0.2em;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: .2em 1em .2em .5em;
  font-size: inherit;
}


.block .filter .comparison .pad {
	margin: 0.2em;
	border-radius: 0.2em;
	background-color: #0081CA;
	color: #FFFFFF;
	font-weight: bold;
	padding: 0 0.2em;
	position: relative;
	width: 1.2em;
	font-size: 1.7em;
	text-align: center;
	border: solid 0.1em #0081CA;
	-webkit-transition: all .2s linear;
	height: 0.9em;
	overflow: hidden;
	vertical-align: revert;
	line-height: 0.9em;
}

.block .filter .comparison .pad {
  margin: 0.2em;
  border-radius: 0.3em;
  background-color: #0081CA;
  color: #FFFFFF;
  font-weight: bold;
  padding: 0 0.2em;
  position: relative;
  width: 2em;
  height: 1.2em;
  line-height: 0.9em;
  overflow: hidden;
  font-size: 1.7em;
  text-align: center;
  border: solid 0.15em #0081CA;
  transition: all .2s linear;
}
.block .filter .comparison .pad.selected {
  background-color: #FFFFFF;
  color: #0081CA;
  border-color: #0081CA;
}
.block .filter .comparison .pad > input {
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  left: -10000px;
  top: -10000px;
}

.block .filter .comparison .pad,
.block .filter .comparison .pad * {
  cursor: pointer;
}
.block .filter .comparison .pad:first-child {
  margin-left: 0;
}
.block .filter .comparison .pad:last-child {
  margin-right: 0;
}

.block:has( .removeBlock:hover ) {
  box-shadow: 1px 1px 3px rgba( 0, 0, 0, 0.5 );
}
/*
*::v-deep > .autocomplete > input {
  direction: rtl;
}
*::v-deep > .autocomplete > input:focus {
  direction: unset;
}
*/

.reqResultsTitle {
  margin: 2em 0 0.5em 0;
  font-weight: bold;
  text-transform: uppercase;
}
.reqResults {
  margin: 1em 0 2em 0;
  border: 1px solid #0081CA;
  border-radius: 0.2em;
}
.reqResults.empty {
	border: none;
	font-weight: bold;
	color: #0081CA;
}
.reqResults th.header {
  font-weight: bold;
  text-transform: uppercase;
  border: solid #0081CA;
  border-width: 0 0 1px 0;
}
.reqResults th,
.reqResults td {
  padding: 0.5em;
  text-align: left;
}
.reqResults th {
  font-weight: bold;
  color: #007BC1;
  background-color: #DBF1FF;
  border: solid #0081CA;
  border-width: 0 1px 1px 0;
}
.reqResults th:last-child {
  border-right-width: 0;
}
.reqResults td {
  border: solid #A0A0A0;
  border-width: 0 1px 1px 0;
}
.reqResults td:last-child {
  border-right-width: 0;
}
.reqResults tr:last-child td {
  border-bottom-width: 0;
}
.reqResults tr:first-child th:first-child {
  border-top-left-radius: 0.2em;
}
.reqResults tr:first-child th:last-child {
  border-top-right-radius: 0.2em;
}
.reqResults tr:last-child td:first-child {
  border-bottom-left-radius: 0.2em;
}
.reqResults tr:last-child td:last-child {
  border-bottom-right-radius: 0.2em;
}
.reqResults tr:nth-child( odd ) td {
  background-color: #F0F0F0;
}
.reqResults tr:hover td {
  background-color: #E8F5FF;
}

.listWrapper {
  margin: 1em 0 0 0;
  position: relative;
}
.listWrapper > .title {
  color: #0081CA;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s linear;
  position: relative;
}
.listWrapper > .title:after {
  content: "^";
  position: absolute;
  right: 0;
  top: 0.3em;
  font-weight: bold;
  font-size: 2em;
  transition: all 0.2s linear;
  transform-origin: center 0;
  transform: rotate( 180deg );
}
.listWrapper > .title.closed:after {
  transform: rotate( 0 );
}

.listWrapper > .title:hover {
  color: #005074;
}

.wrapper > .controls {
  display: flex;
  flex-direction: row;
  margin: 2em 0;
}
.wrapper > .controls > * {
  width: 10em;
  margin-right: 2em;
}

.progress {
  position: fixed;
  top: 5em;
  left: 0.5em;
  width: 32px;
  height: 32px;
  background: url( "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2400 2400' width='24' height='24'%3E%3Cg stroke-width='200' stroke-linecap='round' stroke='%23000' fill='none'%3E%3Cpath d='M1200 600V100'/%3E%3Cpath opacity='.5' d='M1200 2300v-500'/%3E%3Cpath opacity='.917' d='M900 680.4l-250-433'/%3E%3Cpath opacity='.417' d='M1750 2152.6l-250-433'/%3E%3Cpath opacity='.833' d='M680.4 900l-433-250'/%3E%3Cpath opacity='.333' d='M2152.6 1750l-433-250'/%3E%3Cpath opacity='.75' d='M600 1200H100'/%3E%3Cpath opacity='.25' d='M2300 1200h-500'/%3E%3Cpath opacity='.667' d='M680.4 1500l-433 250'/%3E%3Cpath opacity='.167' d='M2152.6 650l-433 250'/%3E%3Cpath opacity='.583' d='M900 1719.6l-250 433'/%3E%3Cpath opacity='.083' d='M1750 247.4l-250 433'/%3E%3CanimateTransform attributeName='transform' attributeType='XML' type='rotate' keyTimes='0;0.08333;0.16667;0.25;0.33333;0.41667;0.5;0.58333;0.66667;0.75;0.83333;0.91667' values='0 1199 1199;30 1199 1199;60 1199 1199;90 1199 1199;120 1199 1199;150 1199 1199;180 1199 1199;210 1199 1199;240 1199 1199;270 1199 1199;300 1199 1199;330 1199 1199' dur='0.83333s' begin='0s' repeatCount='indefinite' calcMode='discrete'/%3E%3C/g%3E%3C/svg%3E" ) 50% 50% no-repeat;
  background-size: 32px;
}
</style>

<style>
.reqResults td:first-child > span {
  font-weight: bold;
  color: #0081CA;
  display: inline-block;
  margin: 0 0.5em;
}
</style>